import PropTypes from 'prop-types';

import ShareButtons from 'hb-react/shared/components/ShareButtons';

const EventShare = ({ title, url, selected }) => (
  <ShareButtons
    url={url}
    title={title}
    selected={selected}
    shareButtonLabel={__('Share event')}
    shareAmplitudeEvent="Events|EventShared"
  />
);

EventShare.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default EventShare;
